import { render, staticRenderFns } from "./ScreenLaudoPelvicaTransvaginalDopplerPreparoIntestinal.vue?vue&type=template&id=5d3a4e0b&lang=true&"
import script from "./ScreenLaudoPelvicaTransvaginalDopplerPreparoIntestinal.vue?vue&type=script&lang=js&"
export * from "./ScreenLaudoPelvicaTransvaginalDopplerPreparoIntestinal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports